export const SET_CLIENTES = "CLIENTES/SET_CLIENTES";
export const SET_CLIENTE = "CLIENTES/SET_CLIENTE";
export const SET_PAGINATION = "CLIENTES/SET_PAGINATION";

export const SET_CLIENTE_USERS = "CLIENTES/SET_CLIENTE_USERS";
export const SET_PAGINATION_USERS = "CLIENTES/SET_PAGINATION_USERS";

export const SET_CLIENTE_PAGAMENTOS = "CLIENTES/SET_CLIENTE_PAGAMENTOS";
export const SET_CLIENTE_ASSINATURA = "CLIENTES/SET_CLIENTE_ASSINATURA";
export const UPDATE_CLIENTE_ASSINATURA = "CLIENTES/UPDATE_CLIENTE_ASSINATURA";
export const REMOVE_CLIENTE_ASSINATURA = "CLIENTES/REMOVE_CLIENTE_ASSINATURA";
export const SET_PAGINATION_PAGAMENTOS = "CLIENTES/SET_PAGINATION_PAGAMENTOS";
export const SET_ERROR = "CLIENTES/SET_ERROR";
